import _extends from "@babel/runtime/helpers/extends";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

/* eslint-disable max-len */
import * as React from 'react';

var DiabetesIcon = function DiabetesIcon() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59 65.9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29,60.29v-3a10.51,10.51,0,0,1-10.5-10.5h-3A13.52,13.52,0,0,0,29,60.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "33.23 39.87 25.89 21.51 18.73 34.4 0 34.4 0 37.4 20.5 37.4 25.45 28.49 32.64 46.47 38.31 37.4 59 37.4 59 34.4 36.65 34.4 33.23 39.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.72,39.4a30.54,30.54,0,0,1,1.78,8,15.5,15.5,0,1,1-31,0,30.54,30.54,0,0,1,1.78-8H12.16a30.75,30.75,0,0,0-1.66,8,18.5,18.5,0,1,0,37,0,30.75,30.75,0,0,0-1.66-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,6.83c3.42,7.11,7.94,17.07,11.22,25.57h3.19C38.49,19.4,30.82,3.7,30.35,2.74L29,0,27.65,2.74c-.47.96-8.14,16.66-13.06,29.66h3.19C21.06,23.9,25.58,13.94,29,6.83Z"
  }))));
};

var _default = DiabetesIcon;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(DiabetesIcon, "DiabetesIcon", "/home/runner/html/nextcloud/apps/ehr/js/platform/ui/src/icons/DiabetesIcon.js");
  reactHotLoader.register(_default, "default", "/home/runner/html/nextcloud/apps/ehr/js/platform/ui/src/icons/DiabetesIcon.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();